export default "__VITE_ASSET__3697bb98__"